// extracted by mini-css-extract-plugin
export default {"root":"ClosingText_root__2we3Y"};